import { getV1, postV1 } from '@/common/utils/ajax'

const getTips = () => getV1('user_tips')

const viewTips = (id) => postV1('user_tip_views', {
    user_tip_id: id
})

const checkTip = (type) => {
    return getTips().then((data) => {
        let tip_id
        data.some(({ id, tip_type }) => {
            if (tip_type === type) {
                tip_id = id
                return true
            }
        })
        return tip_id
    })
}

export default {
    getTips,
    viewTips,
    checkTip
}
